import { useNavigate } from "react-router-dom";
import s from '../styles/App.module.css';

function BackHome(){
    const navigate = useNavigate();

    function Back(){
        navigate('/');
    }

    return (
        <>
            <button onClick={Back} className={s.arrow} aria-label="Закрыть и вернуться на главную">
                <svg 
                    width="32" 
                    height="32" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </>
    );
}

export default BackHome;